import { Container, Stack, Title } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useFindInvoicesByOrganizationId } from "~/gen/api"
import { InvoicesTable } from "~/pages/Brand/Invoices/InvoicesTable.tsx"
import { useAuth } from "~/store/auth-context.tsx"

export const InvoicesWrapper = () => {
  const { t } = useTranslation("invoices")

  const { user } = useAuth()
  const invoicesQuery = useFindInvoicesByOrganizationId()

  if (!user) return null

  return (
    <Container fluid p={0}>
      <Stack pb="sm">
        <Stack px="lg" pt="md">
          <Title order={2}>{t("title")}</Title>
        </Stack>
      </Stack>
      <Container fluid py="xl" px="lg">
        <DataFetchWrapper query={invoicesQuery}>
          {({ data }) => (
            <InvoicesTable
              orgName={user.organization.name}
              invoices={data.data ?? []}
            />
          )}
        </DataFetchWrapper>
      </Container>
    </Container>
  )
}
